import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";

export const AddRowButton: React.FC<{
  title: string;
  onClickAdd: () => void;
}> = ({ title, onClickAdd }) => {
  return (
    <Button className="group transition-all duration-300 shadow-sm hover:shadow-md" size="sm" onClick={onClickAdd}>
      <PlusCircle className="mr-2 h-4 w-4 group-hover:scale-110 transition-transform" />
      {title}
    </Button>
  );
};
